export const CREDIT_FOOTNOTE_TEXT =
    "* Credits are generated from canceled or refunded fees on a student's account " +
    "or transferred from another student's account (such as a sibling's account). " +
    "When appropriate, these credits are allocated to specific fees or outstanding obligations.";
